import React from 'react';

import { defineMessages, useIntl } from 'react-intl';

import SprintIcon from '@atlaskit/icon/core/sprint';
import { token } from '@atlaskit/tokens';

const messages = defineMessages({
	iconLabel: {
		id: 'update-work-item-all-fields-action-renderer.ui.action-card.sprint-field.icon-label',
		defaultMessage: 'Sprint field icon',
		description: 'Label for the sprint field icon',
	},
});

export function SprintFieldIcon(): React.JSX.Element {
	const { formatMessage } = useIntl();
	return (
		<SprintIcon
			label={formatMessage(messages.iconLabel)}
			size="small"
			color={token('color.icon.subtle')}
		/>
	);
}
